/**
* @Author: zachalam
* @Date:   2017-01-19T14:12:03-08:00
* @Last modified by:   Daniel
* @Last modified time: 2017-02-14T10:10:01-08:00
*/


import React, { Component } from 'react';
import Container from '../blocks/Container'
import BlankSlate from '../blocks/BlankSlate'

class NotFound extends Component {
  render() {
    return (
      <Container>
        <BlankSlate
          title="Uh Oh!"
          message="Sorry, we couldn't find the page you're looking for."
        />
      </Container>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/pages/NotFound.jsx